import { updateTenantInfo } from "@/helpers/apis";
import useAppActions from "@/modules/app/useAppActions";
import useAppContext from "@/modules/app/useAppContext";
import { Label, Stack, Switch, Tooltip } from "@altimateai/lego";
import { useState, ChangeEvent } from "react";

const LearningsToggle = () => {
  const [loading, setLoading] = useState(false);
  const {
    state: { teammatesEnabled },
    dispatch,
  } = useAppContext();
  const { fetchTenantInfo } = useAppActions(dispatch);

  const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
    try {
      setLoading(true);
      await updateTenantInfo({ teammatesEnabled: e.target.checked });
      await fetchTenantInfo();
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  return (
    <Stack align="center">
      <Tooltip title={!teammatesEnabled ? "Opt in" : "Opt out"}>
        <div className="flex items-center space-x-2">
          <Switch
            id="toggle-enable-teammates"
            checked={teammatesEnabled}
            disabled={loading}
            onCheckedChange={checked => {
              handleChange({ target: { checked } } as ChangeEvent<HTMLInputElement>);
            }}
          />
          <Label htmlFor="toggle-enable-teammates">{loading ? "Saving..." : null}</Label>
        </div>
      </Tooltip>
    </Stack>
  );
};

export default LearningsToggle;
